/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import Expander from "../../../components/Expander";
import TextExpander from "../../../components/TextExpander";
import { getVarsoUrl, areEqual } from "../../../common/helpers/helpers";
import ComponentPanel from "../../../components/atoms/ComponentPanel/ComponentPanel";
import withErrorGuard from "../../../HOC/withErrorGuard";

const { string, arrayOf, shape } = PropTypes;

const titleDetails = (gene) => {
  return (
    <div className="varsome-right">
      <small style={{ marginRight: "1rem" }}>
        <a
          href={getVarsoUrl(`https://ghr.nlm.nih.gov/gene/${gene}`)}
          target="_blank"
        >
          View this on Genetics Home Reference
        </a>
      </small>
    </div>
  );
};

const GHRGenes = ({ data, gene }) => {
  if (!data || !Array.isArray(data.items)) return null;

  return (
    <div className="varsome-result-fixed">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="GHR Genes"
          version={data.version}
          url={getVarsoUrl("https://ghr.nlm.nih.gov/gene")}
          titleDetailsRight={titleDetails(gene)}
          content={
            <div className="varsome-inner-container">
              {data.items.map((item, i) => {
                return (
                  <div key={i}>
                    {/* dangerouslySetInnerHTML is needed here because we display HTML */}
                    <p dangerouslySetInnerHTML={{ __html: item.html_text }} />
                    <p>
                      <strong>Date published by GHR:</strong>
                      {item.date_published_by_ghr}
                    </p>
                    <h4>Conditions</h4>
                    <table className="varsome-table">
                      <thead>
                        <tr>
                          <th width="20%">Condition</th>
                          <th width="80%">Description</th>
                        </tr>
                      </thead>
                      <Expander showMore="4" component="tbody">
                        {item.conditions_list.map((condition, j) => {
                          return (
                            <tr key={j}>
                              <td>
                                <a
                                  href={getVarsoUrl(condition.ghr_link)}
                                  target="_blank"
                                >
                                  {condition.name}
                                </a>
                              </td>
                              <td>
                                <TextExpander
                                  text={condition.html_text}
                                  truncate="300"
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </Expander>
                    </table>
                  </div>
                );
              })}
            </div>
          }
        />
      </div>
    </div>
  );
};

GHRGenes.propTypes = {
  gene: string,
  data: shape({
    items: arrayOf(
      shape({
        conditions_list: arrayOf(
          shape({
            db_key_list: arrayOf(
              shape({
                gtr: string,
              })
            ),
            ghr_link: string,
            html_text: string,
            name: string,
          })
        ),
        date_published_by_ghr: string,
        html_text: string,
      })
    ),
    version: string,
  }),
};

GHRGenes.defaultProps = {
  gene: "",
  data: null,
};

export default withErrorGuard(
  React.memo(GHRGenes, areEqual),
  "GHRGenes",
  "GHR Genes"
);
